import { render, staticRenderFns } from "./shopForeignInfo.vue?vue&type=template&id=47211242&scoped=true"
import script from "./shopForeignInfo.vue?vue&type=script&lang=js"
export * from "./shopForeignInfo.vue?vue&type=script&lang=js"
import style0 from "./shopForeignInfo.vue?vue&type=style&index=0&id=47211242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47211242",
  null
  
)

export default component.exports